import { phpRequest } from "./phpRequest";

export const removeDevicesAPI = (deviceIds, companyGroupIds, subCompanyIds) => {
  return phpRequest.delete(
    "/devices/remove",
    {},
    {
      data: {
        device_ids: deviceIds,
        company_group_ids: companyGroupIds,
        sub_company_ids: subCompanyIds,
      },
    }
  );
};
